import { render, staticRenderFns } from "./v-checktags.vue?vue&type=template&id=b8f527a4&scoped=true"
import script from "./v-checktags.vue?vue&type=script&lang=js"
export * from "./v-checktags.vue?vue&type=script&lang=js"
import style0 from "./v-checktags.vue?vue&type=style&index=0&id=b8f527a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f527a4",
  null
  
)

export default component.exports